var map = {
	"./female-placeholder.svg": 6516,
	"./gender-icons/female.svg": 31801,
	"./gender-icons/male.svg": 53490,
	"./gender-icons/non_binary.svg": 60422,
	"./gender-icons/other.svg": 9629,
	"./gender-icons/prefer_not_specify.svg": 58905,
	"./male-placeholder.svg": 70503,
	"./non_binary-placeholder.svg": 39747,
	"./unknown-placeholder.svg": 98926,
	"@sword-health/web-ui-kit/src/assets/images/gender/female-placeholder.svg": 6516,
	"@sword-health/web-ui-kit/src/assets/images/gender/gender-icons/female.svg": 31801,
	"@sword-health/web-ui-kit/src/assets/images/gender/gender-icons/male.svg": 53490,
	"@sword-health/web-ui-kit/src/assets/images/gender/gender-icons/non_binary.svg": 60422,
	"@sword-health/web-ui-kit/src/assets/images/gender/gender-icons/other.svg": 9629,
	"@sword-health/web-ui-kit/src/assets/images/gender/gender-icons/prefer_not_specify.svg": 58905,
	"@sword-health/web-ui-kit/src/assets/images/gender/male-placeholder.svg": 70503,
	"@sword-health/web-ui-kit/src/assets/images/gender/non_binary-placeholder.svg": 39747,
	"@sword-health/web-ui-kit/src/assets/images/gender/unknown-placeholder.svg": 98926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21267;